import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20peach%20and%20coral%20tones%2C%20modern%20minimalist%20design%2C%20flowing%20organic%20shapes%2C%20creative%20media%20atmosphere%2C%20elegant%20artistic%20composition%2C%20soft%20light%20effects%2C%20dreamy%20atmosphere%2C%20high%20quality%20abstract%20art&width=1800&height=900&seq=mitao-hero-bg&orientation=landscape"
        alt="蜜桃传媒品牌背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="蜜桃传媒 - 优质内容创作平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-5 md:mb-6 leading-tight">
          让品牌内容更有温度
          <span className="block text-primary-400 mt-2">更具传播力</span>
        </h1>
        <p className="text-background-200 text-base md:text-lg max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          蜜桃传媒是专注于优质内容创作与品牌传播的新媒体平台，汇聚创意制作、短视频运营、社交媒体营销等核心业务，助力品牌实现全域流量增长与影响力突破。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-200 hover:scale-105"
          >
            立即咨询合作
          </Link>
          <Link
            to="/category/short-video"
            className="px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-background-50/10 transition-all duration-200"
          >
            探索内容案例
          </Link>
        </div>
      </div>
    </section>
  );
}